import React from 'react'
import "./footer.css"
const Footer = () => {
  return (
    <div className='footer'>
      <h1>© 2020 All Rights Reserved. Design by Free html Templates</h1>
    </div>
  )
}

export default Footer
